import React from 'react';
import { renderToString } from 'react-dom/server';

import { Wrapper, StatusWrapper, Text } from './StatusCellRenderer.styles';

export const StatusCellRenderer = ({ data }) => {
	const { actual, forecast, status } = data;
	const isOverrun = actual > forecast;

	return renderToString(
		<Wrapper>
			<StatusWrapper isOverrun={isOverrun} />
			<Text>{status}</Text>
		</Wrapper>
	);
};
